<template>
    <div class="dashboard-container">
        <!-- 统计卡片 -->
        <el-row :gutter="20" class="stat-cards">
            <el-col :xs="24" :sm="12" :md="6" v-for="(item, index) in statData" :key="index">
                <div class="stat-card" :class="item.type">
                    <div class="stat-icon">
                        <i :class="item.icon"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">{{ item.label }}</div>
                        <div class="stat-value">{{ item.value }}</div>
                        <div class="stat-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!-- 图表区域 -->
        <el-row :gutter="20" style="margin-top: 20px;">
            <el-col :xs="24" :md="12">
                <div class="card-container">
                    <div class="card-header">
                        <h3 class="card-title">省份分布</h3>
                    </div>
                    <div id="provinceChart" style="height: 400px;"></div>
                </div>
            </el-col>

            <el-col :xs="24" :md="12">
                <div class="card-container">
                    <div class="card-header">
                        <h3 class="card-title">专业分布</h3>
                    </div>
                    <div id="majorChart" style="height: 400px;"></div>
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 20px;">
            <el-col :xs="24">
                <div class="card-container">
                    <div class="card-header">
                        <h3 class="card-title">录取趋势</h3>
                    </div>
                    <div id="trendChart" style="height: 400px;"></div>
                </div>
            </el-col>
        </el-row>

        <!-- 快捷操作 -->
        <div class="card-container" style="margin-top: 20px;">
            <div class="card-header">
                <h3 class="card-title">快捷操作</h3>
            </div>
            <div class="quick-actions">
                <el-button type="primary" icon="el-icon-upload" @click="goTo('/Data/ImportData')">导入考生数据</el-button>
                <el-button type="success" icon="el-icon-picture" @click="goTo('/Data/ImportPhoto')">导入考生照片</el-button>
                <el-button type="warning" icon="el-icon-document" @click="goTo('/Analysis/Report')">生成录取报告</el-button>
                <el-button type="info" icon="el-icon-s-order" @click="goTo('/Info/ListSanBiao')">三表管理</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import * as echarts from 'echarts';

export default {
    name: 'Dashboard',
    inject: ['Loading', 'LoadingCompleted', 'getCurrentYear'],
    data() {
        return {
            statData: [
                {
                    label: '总录取人数',
                    value: '0',
                    desc: '较去年增长 0%',
                    icon: 'el-icon-user',
                    type: 'primary'
                },
                {
                    label: '报到人数',
                    value: '0',
                    desc: '报到率 0%',
                    icon: 'el-icon-success',
                    type: 'success'
                },
                {
                    label: '招生省份',
                    value: '0',
                    desc: '覆盖省份数',
                    icon: 'el-icon-location',
                    type: 'warning'
                },
                {
                    label: '招生专业',
                    value: '0',
                    desc: '开设专业数',
                    icon: 'el-icon-school',
                    type: 'info'
                }
            ],
            charts: {
                province: null,
                major: null,
                trend: null
            },
            chartData: {
                province: [],
                major: [],
                trend: {
                    months: [],
                    values: []
                }
            }
        };
    },
    methods: {
        loadData() {
            const that = this;
            const api_name = '/Analysis/GetDashboard';
            const url = TYBM_Env.GetApiUrl(api_name);
            const year = this.getCurrentYear() || this.$root.currentYear;

            if (!year || year <= 0) {
                that.loadMockData();
                return;
            }

            TYBM_Tools.AxiosGetEx(that, api_name, url + '?year=' + year, { loading_msg: '正在加载数据' })
                .then(result => {
                    if (result.data) {
                        that.updateStatData(result.data);
                        that.saveChartData(result.data);
                        that.initCharts();
                    }
                })
                .catch(error => {
                    console.error('加载数据失败:', error);
                    that.$message.error('加载数据失败，将显示演示数据');
                    that.loadMockData();
                });
        },
        loadMockData() {
            const mockData = {
                totalStudents: 3500,
                reportedStudents: 3320,
                provinceCount: 25,
                majorCount: 48,
                provinceData: [
                    { name: '湖北', value: 580 },
                    { name: '河南', value: 420 },
                    { name: '湖南', value: 380 },
                    { name: '安徽', value: 350 },
                    { name: '江西', value: 320 }
                ],
                majorData: [
                    { name: '计算机科学与技术', value: 280 },
                    { name: '软件工程', value: 260 },
                    { name: '电子信息工程', value: 220 },
                    { name: '机械设计制造', value: 200 },
                    { name: '土木工程', value: 180 }
                ],
                trendData: {
                    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月'],
                    values: [0, 0, 0, 0, 500, 1500, 2800, 3500]
                }
            };

            this.updateStatData(mockData);
            this.saveChartData(mockData);
            this.initCharts();
        },
        saveChartData(data) {
            this.chartData.province = this.convertDataTable(data.provinceData) || [];
            this.chartData.major = this.convertDataTable(data.majorData) || [];
            this.chartData.trend = this.convertTrendData(data.trendData) || { months: [], values: [] };
        },
        convertDataTable(data) {
            if (!data || !Array.isArray(data)) {
                if (data && data.Rows && Array.isArray(data.Rows)) {
                    return data.Rows.map(row => ({
                        name: row.Name || row.name || '',
                        value: row.Value || row.value || 0
                    }));
                }
                return [];
            }
            return data.map(item => ({
                name: item.Name || item.name || '',
                value: item.Value || item.value || 0
            }));
        },
        convertTrendData(data) {
            if (!data) return { months: [], values: [] };
            
            if (data.months && data.values) {
                return { months: data.months, values: data.values };
            }
            
            const rows = Array.isArray(data) ? data : (data.Rows || []);
            if (!rows || rows.length === 0) return { months: [], values: [] };
            
            const monthMap = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
            const monthValues = {};
            
            rows.forEach(row => {
                const month = row.Month || row.month || 0;
                const value = row.Value || row.value || 0;
                if (month >= 1 && month <= 12) {
                    monthValues[month] = value;
                }
            });
            
            let firstMonth = 13;
            let lastMonth = 0;
            for (let i = 1; i <= 12; i++) {
                if (monthValues[i] !== undefined) {
                    firstMonth = Math.min(firstMonth, i);
                    lastMonth = Math.max(lastMonth, i);
                }
            }
            
            if (lastMonth < firstMonth) return { months: [], values: [] };
            
            const months = [];
            const values = [];
            let cumulative = 0;
            
            for (let i = firstMonth; i <= lastMonth; i++) {
                cumulative += monthValues[i] || 0;
                months.push(monthMap[i - 1]);
                values.push(cumulative);
            }
            
            return { months, values };
        },
        updateStatData(data) {
            this.statData[0].value = data.totalStudents || 0;
            this.statData[1].value = data.reportedStudents || 0;
            this.statData[1].desc = '报到率 ' + (data.totalStudents > 0 ? Math.round(data.reportedStudents / data.totalStudents * 100) : 0) + '%';
            this.statData[2].value = data.provinceCount || 0;
            this.statData[3].value = data.majorCount || 0;
        },
        initCharts() {
            setTimeout(() => {
                this.initProvinceChart();
                this.initMajorChart();
                this.initTrendChart();
            }, 100);
        },
        initProvinceChart() {
            const chartDom = document.getElementById('provinceChart');
            if (!chartDom || chartDom.offsetHeight === 0) return;
            
            if (this.charts.province) {
                this.charts.province.dispose();
            }
            
            this.charts.province = echarts.init(chartDom);
            
            const data = this.chartData.province || [];
            const hasData = data.length > 0 && data.some(item => item.value > 0);
            
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}人 ({d}%)'
                },
                legend: hasData ? {
                    orient: 'horizontal',
                    bottom: '5%',
                    left: 'center',
                    itemGap: 16,
                    textStyle: {
                        fontSize: 11
                    },
                    pageTextStyle: {
                        fontSize: 11
                    }
                } : { show: false },
                series: [
                    {
                        name: '省份分布',
                        type: 'pie',
                        radius: ['40%', '65%'],
                        center: ['50%', '40%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderRadius: 4,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: hasData ? {
                            show: true,
                            formatter: '{b}\n{c}人',
                            fontSize: 10,
                            lineHeight: 14
                        } : { show: false },
                        labelLine: {
                            show: true,
                            length: 15,
                            length2: 10
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        data: hasData ? data : [{ name: '暂无数据', value: 1 }],
                        color: hasData ? undefined : ['#e4e7ed']
                    }
                ]
            };
            
            this.charts.province.setOption(option);
            this.charts.province.resize();
        },
        initMajorChart() {
            const chartDom = document.getElementById('majorChart');
            if (!chartDom || chartDom.offsetHeight === 0) return;
            
            if (this.charts.major) {
                this.charts.major.dispose();
            }
            
            this.charts.major = echarts.init(chartDom);
            
            const data = this.chartData.major || [];
            const hasData = data.length > 0 && data.some(item => item.value > 0);
            
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}人 ({d}%)'
                },
                legend: hasData ? {
                    orient: 'horizontal',
                    bottom: '5%',
                    left: 'center',
                    itemGap: 16,
                    textStyle: {
                        fontSize: 11
                    },
                    pageTextStyle: {
                        fontSize: 11
                    }
                } : { show: false },
                series: [
                    {
                        name: '专业分布',
                        type: 'pie',
                        radius: ['40%', '65%'],
                        center: ['50%', '40%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderRadius: 4,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: hasData ? {
                            show: true,
                            formatter: '{b}\n{c}人',
                            fontSize: 10,
                            lineHeight: 14
                        } : { show: false },
                        labelLine: {
                            show: true,
                            length: 15,
                            length2: 10
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        data: hasData ? data : [{ name: '暂无数据', value: 1 }],
                        color: hasData ? undefined : ['#e4e7ed']
                    }
                ]
            };
            
            this.charts.major.setOption(option);
            this.charts.major.resize();
        },
        initTrendChart() {
            const chartDom = document.getElementById('trendChart');
            if (!chartDom || chartDom.offsetHeight === 0) return;
            
            if (this.charts.trend) {
                this.charts.trend.dispose();
            }
            
            this.charts.trend = echarts.init(chartDom);
            
            const trendData = this.chartData.trend || { months: [], values: [] };
            const hasData = trendData.months && trendData.months.length > 0;
            
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}<br/>录取人数: {c}人'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: hasData ? trendData.months : ['暂无数据']
                },
                yAxis: {
                    type: 'value',
                    name: '人数'
                },
                series: [
                    {
                        name: '录取趋势',
                        type: 'line',
                        smooth: true,
                        data: hasData ? trendData.values : [0],
                        lineStyle: {
                            width: 3,
                            color: '#409EFF'
                        },
                        areaStyle: hasData ? {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
                                { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
                            ])
                        } : { show: false },
                        itemStyle: {
                            color: '#409EFF'
                        }
                    }
                ]
            };
            
            this.charts.trend.setOption(option);
            this.charts.trend.resize();
        },
        goTo(path) {
            this.$router.push(path);
        }
    },
    mounted() {
            const year = this.getCurrentYear() || this.$root.currentYear;
            
            if (year && year > 0) {
                this.loadData();
            } else {
                this.loadMockData();
            }

            this.$root.$on('global-year-change', (newYear) => {
                if (newYear && newYear > 0) {
                    this.loadData();
                }
            });

            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            // 销毁图表
            if (this.charts.province) {
                this.charts.province.dispose();
            }
            if (this.charts.major) {
                this.charts.major.dispose();
            }
            if (this.charts.trend) {
                this.charts.trend.dispose();
            }

            // 移除事件监听
            this.$root.$off('global-year-change');
            window.removeEventListener('resize', this.handleResize);
        },
        handleResize() {
            if (this.charts.province) {
                this.charts.province.resize();
            }
            if (this.charts.major) {
                this.charts.major.resize();
            }
            if (this.charts.trend) {
                this.charts.trend.resize();
            }
        }
};
</script>

<style scoped>
.dashboard-container {
    padding: 0;
}

.stat-cards {
    margin-top: 20px;
}

.stat-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    padding: 24px;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.stat-card.primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-card.success {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stat-card.warning {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.stat-card.info {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stat-icon {
    font-size: 48px;
    opacity: 0.8;
}

.stat-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.stat-label {
    font-size: 14px;
    opacity: 0.9;
}

.stat-value {
    font-size: 32px;
    font-weight: bold;
}

.stat-desc {
    font-size: 12px;
    opacity: 0.8;
}

.quick-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.quick-actions .el-button {
    padding: 12px 24px;
    font-size: 14px;
}

@media (max-width: 768px) {
    .stat-card {
        padding: 16px;
    }

    .stat-icon {
        font-size: 36px;
    }

    .stat-value {
        font-size: 24px;
    }

    .quick-actions .el-button {
        width: 100%;
    }
}
</style>

